'use client';

import React, { createContext, useState } from 'react';
import { CookieBanner } from '../../components';


type CookiesConsentContext = {
  cookiesConsented: boolean,
  setCookiesConsented: (cookiesConsent: boolean) => void,
}

const Context = createContext({} as CookiesConsentContext);

export const CookiesConsentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [cookiesConsented, setCookiesConsented] = useState<boolean>(false);

  return (
    <Context.Provider value={{
      cookiesConsented,
      setCookiesConsented,
    }}
    >
      {children}
      <CookieBanner />
    </Context.Provider>
  );
};

export const useCookiesConsent = () => React.useContext(Context);
